export default __webpack_public_path__ + "static/media/grad.88bcc0bc.png";